// extracted by mini-css-extract-plugin
export default {"container":"mp-z","brandName":"np-z","productName":"op-z","productNamePdpEnhancements":"pp-z","breakLongProductName":"qp-z"};